import { LayoutComponent } from "@jelly/lesson";
import config from "appConfig";

const components: Record<string, LayoutComponent> = {
  "5:1": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/sum-of-modes/pressure-modulus-450-1-mode.png`,
        },
      },
    },
  },
  "5:2": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/sum-of-modes/pressure-modulus-450-2-modes.png`,
        },
      },
    },
  },
  "5:3": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/sum-of-modes/pressure-modulus-450-3-modes.png`,
        },
      },
    },
  },
  "5:4": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/sum-of-modes/pressure-modulus-450-4-modes.png`,
        },
      },
    },
  },
  "5:5": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/sum-of-modes/pressure-modulus-450-5-modes.png`,
        },
      },
    },
  },
};

export default components;
